// export const Base_url_live = ""
// export const Base_url = "http://localhost:3000/api/v1"
// export const Base_url_bbbs = "http://localhost:4444/bbps/api"


// export const Base_url = "https://www.xopay.in/api/v1/"


// export const Base_url_api_live = "http://localhost:3000/api/v1/"
// export const Base_url = "http://localhost:3000/api/v1/"


export const Base_url_api_live = "https://dev.xopay.in/api/v1/"
export const Base_url = "https://dev.xopay.in/api/v1/"


export const Base_url_bbbslive = "https://dev.xopay.in/bbps/api"
export const Base_url_live = "https://dev.xopay.in/bbps/api" 
export const Base_url_bbbs = "https://dev.xopay.in/bbps/api"
export const Base_url_imggg = "https://dev.xopay.in/bbps/api/transactionstatus/img?img=" 


// export const Base_url_bbbslive = "https://uat.xopay.in/bbps/api"

//  export const Base_url_api_live = "https://uat.xopay.in/api/v1/"
//  export const Base_url_live = "https://uat.xopay.in/bbps/api"
//  export const Base_url = "https://uat.xopay.in/api/v1/"
// export const Base_url_bbbs = "https://uat.xopay.in/bbps/api"
// export const Base_url_imggg = "https://uat.xopay.in/bbps/api/transactionstatus/img?img=" 







// export const Base_url_bbbslive = "http://65.0.122.89:4444/bbps/api"

//  export const Base_url_api_live = "http://65.0.122.89:3000/api/v1/"
//  export const Base_url_live = "http://65.0.122.89:4444/bbps/api"
//  export const Base_url = "http://65.0.122.89:3000/api/v1/"
// export const Base_url_bbbs = "http://65.0.122.89:4444/bbps/api"
// export const Base_url_imggg = "http://www.xopay.in/bbps/api/transactionstatus/img?img=" 









//  export const Base_url = "http://192.168.1.76:3000/api/v1"
//  export const Base_url_bbbs = "http://192.168.1.76:3000/api"

export const ivs_key = 'abcrtf9876541110abcdef9876543299'
export const secret_key = '0123456789abcdefr543456789abcdy7'